<template>
<div>
  <div>
    <h3 class="page-heading">Users</h3>
  </div>
  <div class="text-center">
    <button class="btn btn-outline-primary" @click="goToSentVerification()">Next</button>
  </div>

</div>
</template>

<script>

export default {
  data () {
    return {}
  },
  methods: {
    goToSentVerification () {
      this.$router.push('sent-verification')
    }
  }
}
</script>
<style scoped>
.btn {
  margin: 5px;
}
.card-deck {
  margin-top: 20px;
}

.card {
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-radius: 0.5rem;
  height: 70vh;
  margin-right: 40px;
}

.card-header {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}

.btn-default {
  border: 0.5px solid;
  background: grey;
  color: #fff;
}

.plan-desc {
  text-transform: uppercase;
}

.page-heading {
  text-transform: uppercase;
}

.next {
  text-transform: uppercase;
  margin-top: 60vh;
}

.card:hover{
  border-color: #47b784;
}

.card:hover .btn {
  background-color: #47b784;
  color: #fff;
}

.card:hover .card-header {
  background-color: #47b784;
  color: #fff;
}

.card-active .card-header {
  background-color: #47b784;
  color: #fff;
}

.card-active .btn {
  background-color: #47b784;
  color: #fff;
}

.card-active .card {
  border-color: #47b784;
}

.selectPlanFrequency:hover, .active{
  background-color: #47b784;
  color: #fff;
}

.choose-plan {
  position: absolute;
  right: 80px;
  bottom: 0;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/Users.vue